import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const columns = (history, showModal) => [
  {
    title: "Code",
    dataIndex: "productCode",
    key: "productCode",

    
  },
  {
    title: "Nom du Produit",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Prix",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "Action",
    key: "action",
    width: 200, // Largeur fixe recommandée
      render: (record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          
          {/* BOUTON MODIFIER (Bleu foncé arrondi) */}
          <Button
            className="btn-details" 
            onClick={() => history.push(`edit/produit/${record.id}`)}
            icon={<EditOutlined />}
          >
            Modifier
          </Button>

          {/* BOUTON SUPPRIMER (Icône Rouge) */}
          <Button 
              type="text" 
              danger 
              onClick={() => showModal(record.id)}
              icon={<DeleteOutlined style={{ fontSize: '18px' }} />}
          />
        </div>
    ),
  },
];
